module.exports = __webpack_public_path__ + "img/loading.f51f2004.svg";